import { gql } from '@urql/core';

export const GET_FOLDERS = gql`
  query GetFolders {
    folders {
      name
      id
      parentId
      position
      children
      color
      description
      contentsCount
    }
  }
`;

export const CREATE_FOLDER = gql`
  mutation createFolder($input: CreateFolderInput!) {
    createFolder(input: $input) {
      id
      name
      updatedAt
    }
  }
`;

export const DELETE_FOLDER = gql`
  mutation DeleteFolder($id: UUID4!) {
    deleteFolder(id: $id) {
      success
    }
  }
`;

export const GET_CONTENTS = gql`
  query GetContents(
    $filter: ContentFilter
    $pageInfo: PageInput
    $sort: [ContentSortOrder!]
  ) {
    contents(filter: $filter, pageInfo: $pageInfo, sort: $sort) {
      content {
        id
        name
        type
        updatedAt
        state
        published
        publishedAndDirty
        folder {
          id
          name
        }
      }
      pageInfo {
        total
        offset
        limit
      }
    }
  }
`;

export const UPDATE_FOLDER = gql`
  mutation UpdateFolder($input: UpdateFolderInput!) {
    updateFolder(input: $input) {
      id
    }
  }
`;

export const MOVE_FOLDER = gql`
  mutation moveFolder(
    $from: UUID4
    $to: UUID4
    $id: UUID4!
    $newPosition: Int!
  ) {
    moveFolder(from: $from, to: $to, id: $id, newPosition: $newPosition) {
      id
      name
      parentId
    }
  }
`;

export const SET_FOLDER_FOR_IDS = gql`
  mutation setFolderForIds($ids: [String!]!, $folderId: UUID4) {
    setFolderForIds(ids: $ids, folderId: $folderId) {
      success
    }
  }
`;

export const GET_ACCOUNT_ID = gql`
  query GetAccountId {
    account {
      id
    }
  }
`;

export const GET_ACCOUNT_USERS = gql`
  query GetAccountUsers($filter: AccountUserFilter) {
    accountUsers(filter: $filter) {
      user {
        id
        fullName
      }
    }
  }
`;

export const GET_SEGMENTS = gql`
  query GetSegments(
    $filter: SegmentFilter
    $page: Page
    $sort: [SegmentSortOrder!]
  ) {
    segmentsV2(filter: $filter, page: $page, sort: $sort) {
      segments {
        id
        name
      }
      pageInfo {
        total
      }
    }
  }
`;

export const GET_TAGS = gql`
  query GetTags {
    tags {
      id
      name
    }
  }
`;

export const PUBLISH_CONTENT = gql`
  mutation PublishContent($id: String!) {
    publishContent(id: $id) {
      message
    }
  }
`;

export const UNPUBLISH_CONTENT = gql`
  mutation UnpublishContent($id: String!) {
    unpublishContent(id: $id) {
      message
    }
  }
`;
